module.exports = __webpack_public_path__ + "static/img/BELMONT-MAPLE.ad0e259.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/BELMONT-MAPLE.png
// module id = XrwK
// module chunks = 0